import DisableScroll from "./disable-scroll";

// Disable scroll
window.disableScroll = new DisableScroll();

// Ajax requests
window.ajaxReq = function ajaxReq() {
  if (window.XMLHttpRequest) {
    return new XMLHttpRequest(); // eslint-disable-line
  }

  if (window.ActiveXObject) {
    return new ActiveXObject("Microsoft.XMLHTTP"); // eslint-disable-line no-console
  }

  console.log("Browser does not support XMLHTTP."); // eslint-disable-line no-console
  return false;
};

// Set animations
window.setAnimationScenes = function setAnimationScenes(scrollMagicController) {
  const animatableElements = [
    ".facts",
    ".featured-content",
    ".featured-links",
    ".gallery",
    ".grid-card",
    ".numbers",
    ".process",
    ".projects-grid-card",
    ".team",
    ".text .col-group",
    ".timeline",
  ];
  // Set animation classes to all the elements that will use them.
  /* eslint-disable no-restricted-syntax */
  import(/* webpackChunkName: "library-scrollmagic" */ "scrollmagic").then(
    ({ default: ScrollMagic }) => {
      for (const el of Array.from(
        document.querySelectorAll(animatableElements.join(","))
      )) {
        new ScrollMagic.Scene({
          triggerElement: el,
          triggerHook: "onEnter",
          reverse: false,
        })
          .setClassToggle(el, "animated")
          .addTo(scrollMagicController);
      }
    }
  );
  /* eslint-enable no-restricted-syntax */
};

// Load JS scripts
window.loadJS = function loadJS(file, callback) {
  if (document.body.querySelector(`script[src*="${file}"]`) != null) {
    callback();
    return;
  }

  // DOM: Create the script element
  const jsElm = document.createElement("script");
  // set the type attribute
  jsElm.type = "text/javascript";
  // make the script element load file
  jsElm.src = file;
  // add a callback
  jsElm.addEventListener("load", callback);
  // finally insert the element to the body element in order to load the script
  document.body.appendChild(jsElm);
};

// Toggle video source
window.toggleVideoSource = function toggleVideoSource(video, breakpoint) {
  const currentVideo = video;
  if (currentVideo) {
    const videoSource = currentVideo.getAttribute("data-src");

    if (videoSource) {
      let smallScreen = true;

      if (window.innerWidth >= breakpoint) {
        smallScreen = false;
      }

      if (
        (smallScreen === false && currentVideo.src === "" && videoSource) ||
        (smallScreen === false && currentVideo.src === null && videoSource)
      ) {
        currentVideo.src = videoSource;

        currentVideo.load();

        currentVideo.addEventListener("canplaythrough", () => {
          currentVideo.play();
        });
      } else if (smallScreen === true && currentVideo.src) {
        currentVideo.src = "";
        currentVideo.removeAttribute("src");
      }
    }
  }
};

// Destroy ScrollMagic scenes
window.destroyScrollMagicScenes = function destroyScrollMagicScenes(scene) {
  if (
    typeof window.loadModulesScrollMagic === "object" &&
    !Array.isArray(window.loadModulesScrollMagic) &&
    window.loadModulesScrollMagic !== null
  ) {
    window.loadModulesScrollMagic.destroy(true);
  }
  if (scene === "animations" || scene === null) {
    if (
      typeof window.animationScrollMagic === "object" &&
      !Array.isArray(window.animationScrollMagic) &&
      window.animationScrollMagic !== null
    ) {
      window.animationScrollMagic.destroy(true);
    }
  }
};
